export const removeWhiteSpaces = (value: string) => value.replace(/\s/g, '')
export const mask = (str: string) => str.slice(-4).padStart(str.length, '*')

export function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
